<template>
    <b-row class="tecno" align-h="start">
        <b-col cols="12" class="tecno-content-titulo" lg="5">

                    <p class="tecno-titulo" v-html="content.titulo"></p>
            
                 <p class="tecno-content" v-html="content.content"></p>
               
           
        </b-col>
        <b-col cols="12" lg="7" class="tecno-content-image">
            <img class="tecno-imagen" :src="srcImagen" alt="Imagen Tecnologia">
        </b-col>
        <b-col cols="12" lg="12">
            <b-row align-h="center" class=" justify-content-lg-center mt-5 pb-5 content-block"  >
                <br>
                <b-col cols="12" lg="1" class="block-small2">
                </b-col>
                <block-small v-for="(item, index) in content.blocks" 
                :key="index" 
                :content="item"
                />
                <b-col cols="12" lg="1" class="block-small2">
                </b-col>
            </b-row>
        </b-col>
        <!--<b-col cols="12"  lg="12" class="mt-5 pb-5 function-spase-7">-->
        <!--</b-col>-->
    </b-row>
</template>
<script>
    import BlockSmall from '@/components/BlockSmall'

    export default {
        name: 'section-tecno',
        components: {
            BlockSmall
        },
        props: {
            content: Object
        },
        data: () => ({

        }),
        computed: {
            srcImagen() {
                let src = require('@/assets/images/commerce_internal/' + this.content.imagen)
                return src
            }
        }
    }
</script>
<style scoped>

@media (max-width: 600px) {
    .tecno-titulo {
        font-size: 35px;
        margin: 0px;
    }

    .tecno-content {
        margin: 0px;
    }

    .tecno-content-image{}
}

</style>